export const deleteData = async url => {
  const response = await fetch(url, {
    method: 'DELETE',
  });

  if (!response.ok) {
    throw new Error('Delete request failed');
  }

  return response;
};
